<template>
  <div>
    <fluke-card>
      <header>
        <div class="title">Adicionar Novo PDF</div>
        <div class="description">
          Crie uma nova versão de um arquivo de Termo
        </div>
      </header>
      <main>
        Selecione o tipo:
        <v-radio-group v-model="model.term_type" row>
          <v-radio
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </v-radio>
        </v-radio-group>
        <fluke-input-file
          label="PDF"
          accept="application/pdf"
          :file="model.file"
          @change="setFile"
          @remove="removeFile"
        />
        <v-text-field label="Nome" v-model="model.name"></v-text-field>
        <p v-if="previewFileName">
          <em
            >Preview do nome do arquivo:
            <strong>{{ previewFileName }}</strong></em
          >
        </p>
      </main>
      <footer>
        <fluke-button v-on:click.native="submit">Adicionar</fluke-button>
      </footer>
    </fluke-card>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import Card from "../../components/Main/Content/Card/Card.vue";
import Button from "../../components/Main/Content/Button/Button.vue";
import InputFile from "../../components/Main/Content/InputFile/InputFile";
import permission from "../../mixins/permissions";

export default {
  mixins: [permission],
  components: {
    "fluke-card": Card,
    "fluke-button": Button,
    "fluke-input-file": InputFile,
  },
  data: function () {
    return {
      model: {
        file: null,
        name: "",
        term_type: "1",
      },
      permission: {
        read: false,
        write: false,
      },
      newVersion: 1,
    };
  },
  created: function () {
    this.permission = this.getUserPagePermission("term_files");
    if (this.permission.read == false || this.permission.write == false) {
      this.$router.push("/");
    }
    this.loadLatestVersion();
  },
  methods: {
    submit: async function () {
      const formData = new FormData();
      formData.set("term_type", this.model.term_type);
      formData.set("name", this.model.name);
      formData.append("file", this.model.file);
      const { data } = await axios.post(
        this.$myServerAddresses.courses + "term_files",
        formData,
        {
          headers: {
            "X-Fluke": this.$cookies.get("token"),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (data) {
        this.$router.push({ name: "term_files" });
      } else {
        this.$store.commit(
          "flash_warning",
          "Não foi possível cadastrar o novo PDF, verifique os campos e tente novamente"
        );
      }
    },
    setFile(event) {
      this.model.file = event.target.files[0];
      this.model.name = this.createSlug(
        this.model.file.name.split(".").slice(0, -1).join(".")
      );
    },
    removeFile() {
      this.model.file = null;
    },
    async loadLatestVersion() {
      const termType = +this.model.term_type === 1 ? "privacy" : "auth";
      const { data } = await axios.get(
        this.$myServerAddresses.courses +
          "term_files/latest?term_type=" +
          termType
      );
      if (data) {
        this.newVersion = +data.version + 1;
      } else {
        this.newVersion = 1;
      }
    },
    createSlug(value) {
      const acceptdChars = [" ", "-"];
      const lastChar = value[value.length - 1];
      const prependChar = acceptdChars.includes(lastChar) ? "-" : "";
      const newValue = _.kebabCase(value) + prependChar;
      return newValue;
    },
  },
  computed: {
    fileExtension() {
      if (this.model.file) {
        return this.model.file.name.split(".").pop();
      }
    },
    previewFileName() {
      if (this.model.name && this.model.file) {
        return `${this.model.name}-v${this.newVersion}.${this.fileExtension}`;
      }
      return "";
    },
    options() {
      return [
        {
          label: "Privacidade",
          value: "1",
        },
        {
          label: "Uso de Imagem/Video",
          value: "2",
        },
      ];
    },
  },
  watch: {
    "model.term_type": function (value) {
      this.$nextTick(() => {
        this.loadLatestVersion();
      });
    },
    "model.name": function (value, oldValue) {
      this.$nextTick(() => {
        if (value !== oldValue && value && oldValue) {
          this.model.name = this.createSlug(value);
        }
      });
    },
  },
};
</script>
